export enum LocationType {
    Residential = "RESIDENTIAL",
    Industrial = "INDUSTRIAL",
    Other = "OTHER",
}

export enum ConfirmationActionType {
    LOCATION_INVITE = "LOCATION_INVITE",
}

export enum LocationViewType {
    LATEST = "latest",
    REALTIME = "realtime",
}

export enum ChartDataInterval {
    MINUTE = "minute",
    QUARTER_HOUR = "quarter_hour",
    HOUR = "hour",
    DAY = "day",
    MONTH = "month",
    AUTO = "auto",
}

export enum ChartDataType {
    POWER = "power",
    ENERGY = "energy",
    AUTO = "auto",
}

export enum ChartDataDisplay {
    COMBINE = "combine",
    SPLIT = "split",
}

export interface DateRange {
    from: Date
    to: Date
}

export interface Price {
    amount: Number
    currency: String
}
